import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AppUpdateService } from '@falcon/app/shared/services/app-update/app-update.service';
import { TranslateService } from '@ngx-translate/core';
import { Observable, tap } from 'rxjs';

const CLIENT_VERSION_HEADER_KEY = 'x-boemm-client-version';
const APP_LANG_HEADER_KEY = 'Accept-Language';

@Injectable()
export class GeneralInterceptor implements HttpInterceptor {
  private appUpdateService = inject(AppUpdateService);
  private translateService = inject(TranslateService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const currAppLang = this.translateService.currentLang;
    if (currAppLang) {
      req = req.clone({ headers: req.headers.set(APP_LANG_HEADER_KEY, currAppLang) });
    }
    return next.handle(req).pipe(tap(this.setAppServerVersion.bind(this)));
  }

  private setAppServerVersion(event: HttpEvent<any>): void {
    if (!(event instanceof HttpResponse)) return;

    const serverAppVersion = event.headers.get(CLIENT_VERSION_HEADER_KEY);

    if (!serverAppVersion) return;

    this.appUpdateService.setServerAppVersion(serverAppVersion);
  }
}
